export enum SortType {
    ALPHABETICAL,
    NUMERICAL,
    BUERGSCHEIN_NUMBER
}
